export default {
  eur: {
    isoCode: 'EUR',
    name: 'Euro',
    symbol: '€',
    decimalMark: ',',
    thousandsSeparator: '.'
  },

  gbp: {
    isoCode: 'GBP',
    name: 'British Pound',
    symbol: '£',
    decimalMark: '.',
    thousandsSeparator: ','
  },

  usd: {
    isoCode: 'USD',
    name: 'United States Dollar',
    symbol: '$',
    decimalMark: '.',
    thousandsSeparator: ','
  }
};
